import React from 'react';
export const Form = ({ title, setTitle, desc, setDesc, notes, setNotes }) => {
  const inputHandler = (e) => {
    if (e.target.id === "Notetitle") setTitle(e.target.value);
    else setDesc(e.target.value);
  };
  const addNotesHandler = (e) => {
    e.preventDefault();
    if (title && desc) {
      const newNote = {
        id: Date.now(),  // unique number
        title,
        desc
      };
      setNotes(prev => [...prev, newNote]);
      setTitle("");
      setDesc("");
    }
  };
  return (
    <div className="container" >
      <div className="row justify-content-center my-3 ">
        <div className="col-md-10">
          <form style={{ border: "2px solid #a7f2faff", padding: "20px", borderRadius: "10px" ,backgroundColor:"#daf3f8ff"}}>
            <div className="mb-3">
              <label htmlFor="Notetitle" className="form-label" ><h5>Title</h5></label>
              <input type="text" className="form-control" id="Notetitle" placeholder="Enter Title" style = {{backgroundColor: "#dff4faff", border:"1px solid #101819ff"}}value={title} onChange={inputHandler} />
            </div>
            <div className="mb-3">
              <label htmlFor="desc" className="form-label">Description</label>
              <textarea name="desc" rows="3" className="form-control" id="desc" placeholder="Enter Description"style = {{backgroundColor: "#dff4faff", border:"1px solid #101819ff"}} value={desc} onChange={inputHandler} />
            </div>
            <button type="submit" className="btn btn-primary" onClick={addNotesHandler} style = {{backgroundColor: '#013b45ff', borderRadius: '6px', color: 'white', fontWeight: '500',border:"1px solid white"}}>Add Notes</button>
          </form>
        </div>
      </div>
    </div>
  );
};


